import React from 'react';
import styled from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockPost } from '../../blocks/BlockPost';
import { BlockCollage } from '../../blocks/BlockCollage';
import { BlockInfo, blockInfoHasContent } from '../../blocks/BlockInfo';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { PostBlockLayoutProps } from './PostLayout';
import { BlockLayoutProps } from '../../types/component';
import { css } from 'styled-components';

export const PostBlockLayoutCollage = (props: PostBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const renderInfo = blockInfoHasContent(props.blocks[0]);

  return (
    <StyledBlockLayout {...props} renderInfo={renderInfo}>
      <StyledBlockCollage {...innerProps} block={props.blocks[0]} />
      {renderInfo && <StyledBlockInfo {...innerProps} block={props.blocks[0]} />}
      <StyledBlockPost {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const PostHeightMap = {
  small: 1,
  medium: 2,
  large: 3,
};

const getPostPadding = (props: BlockLayoutProps) => {
  const defaultHeight = 'small';
  const multiplier = PostHeightMap[props.height ?? defaultHeight];

  return css`
    padding: calc(var(--unit-length) * ${multiplier}) var(--unit-length);
  `;
};

const StyledBlockInfo = styled(BlockInfo)``;
const StyledBlockCollage = styled(BlockCollage)``;
const StyledBlockPost = styled(BlockPost)``;

const StyledBlockLayout = styled(BlockLayout)<{
  renderInfo: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${StyledBlockCollage} {
    position: relative;
    z-index: 1;
  }

  ${StyledBlockInfo} {
    min-height: ${(props) => {
      switch (props.height) {
        case 'medium':
          return '40vh';
        case 'large':
          return '55vh';
        default:
          return undefined;
      }
    }};
  }

  ${StyledBlockPost} {
    ${getPostPadding}
    padding-top: ${(props) => (props.renderInfo ? '0' : undefined)};
  }
`;

